export const UPDATE_WALLET_PAYMENT_DATA = 'wallet/UPDATE_WALLET_PAYMENT_DATA';
